import PropTypes from "prop-types";
import { Empty } from "antd";

const EmptyFeedback = ({ children, hideIcon = false }) => {
    return (
        <div className="max-h-[600px] flex-center-column flex-grow">
            <div className="py-6 px-16 bg-white flex flex-col items-center justify-center gap-3">
                {!hideIcon && (
                    <Empty description={false} />
                )}

                {children}
            </div>
        </div>
    )
}

EmptyFeedback.propTypes = {
    children: PropTypes.any,
    hideIcon: PropTypes.bool,
};

export default EmptyFeedback;
